import { render, staticRenderFns } from "./News-right.vue?vue&type=template&id=6b30cd18&scoped=true&"
import script from "./News-right.vue?vue&type=script&lang=js&"
export * from "./News-right.vue?vue&type=script&lang=js&"
import style0 from "./News-right.vue?vue&type=style&index=0&id=6b30cd18&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b30cd18",
  null
  
)

export default component.exports